import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Textarea } from '../ui/textarea';
import { Checkbox } from '../ui/checkbox';
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '../ui/dialog';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { HOLIDAY_TYPES, COUNTRIES } from './bibliothequeConstants';

const BibliothequeHolidayFormDialog = ({
  open, onOpenChange,
  editingHoliday, setEditingHoliday,
  formData, setFormData,
  handleSubmit, resetForm,
}) => {
  const { t } = useTranslation();

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="max-w-2xl">
      <DialogHeader>
        <DialogTitle>{editingHoliday ? t("holidayLibraryComponents.form.titleEdit") : t("holidayLibraryComponents.form.titleNew")}</DialogTitle>
        <DialogDescription>
          {editingHoliday ? t("holidayLibraryComponents.form.descEdit") : t("holidayLibraryComponents.form.descNew")}
        </DialogDescription>
      </DialogHeader>
      <form onSubmit={handleSubmit}>
        <div className="grid gap-4 py-4">
          <div className="grid grid-cols-2 gap-4">
            <div className="space-y-2">
              <Label htmlFor="name">{t("holidayCommon.fields.name")} *</Label>
              <Input
                id="name"
                value={formData.name}
                onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                required
              />
            </div>
            <div className="space-y-2">
              <Label htmlFor="date">{t("holidayCommon.fields.date")} *</Label>
              <Input
                id="date"
                type="date"
                value={formData.date}
                onChange={(e) => setFormData({ ...formData, date: e.target.value })}
                required
              />
            </div>
          </div>

          <div className="grid grid-cols-3 gap-4">
            <div className="space-y-2">
              <Label htmlFor="year">{t("holidayCommon.fields.year")} *</Label>
              <Input
                id="year"
                type="number"
                value={formData.year}
                onChange={(e) => setFormData({ ...formData, year: e.target.value })}
                required
              />
            </div>
            <div className="space-y-2">
              <Label htmlFor="type">{t("holidayCommon.fields.type")} *</Label>
              <Select value={formData.type} onValueChange={(value) => setFormData({ ...formData, type: value })}>
                <SelectTrigger><SelectValue /></SelectTrigger>
                <SelectContent>
                  {Object.keys(HOLIDAY_TYPES).map((value) => (
                    <SelectItem key={value} value={value}>{t(`holidayCommon.types.${value}`)}</SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>
            <div className="space-y-2">
              <Label htmlFor="country">{t("holidayCommon.fields.country")}</Label>
              <Select value={formData.country} onValueChange={(value) => setFormData({ ...formData, country: value })}>
                <SelectTrigger><SelectValue /></SelectTrigger>
                <SelectContent>
                  {COUNTRIES.map((country) => (
                    <SelectItem key={country} value={country}>{country}</SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>
          </div>

          <div className="flex items-center space-x-2">
            <Checkbox
              id="is_recurring"
              checked={formData.is_recurring}
              onCheckedChange={(checked) => setFormData({ ...formData, is_recurring: checked })}
            />
            <Label htmlFor="is_recurring" className="cursor-pointer">
              {t("holidayLibraryComponents.form.recurring")}
            </Label>
          </div>

          {formData.is_recurring && (
            <div className="space-y-2">
              <Label htmlFor="recurrence_pattern">{t("holidayLibraryComponents.form.recurrencePattern")}</Label>
              <Input
                id="recurrence_pattern"
                placeholder={t("holidayLibraryComponents.form.recurrencePlaceholder")}
                value={formData.recurrence_pattern}
                onChange={(e) => setFormData({ ...formData, recurrence_pattern: e.target.value })}
              />
            </div>
          )}

          <div className="space-y-2">
            <Label htmlFor="description">{t("holidayCommon.fields.description")}</Label>
            <Textarea
              id="description"
              value={formData.description}
              onChange={(e) => setFormData({ ...formData, description: e.target.value })}
              rows={3}
            />
          </div>
        </div>
        <DialogFooter>
          <Button
            type="button"
            variant="outline"
            onClick={() => {
              onOpenChange(false);
              setEditingHoliday(null);
              resetForm();
            }}
          >
            {t("holidayCommon.cancel")}
          </Button>
          <Button type="submit">{editingHoliday ? t("holidayCommon.edit") : t("holidayCommon.create")}</Button>
        </DialogFooter>
      </form>
    </DialogContent>
    </Dialog>
  );
};

export default BibliothequeHolidayFormDialog;
